import { render, staticRenderFns } from "./GarageDoorDescription.vue?vue&type=template&id=8bd66fe4&scoped=true"
import script from "./GarageDoorDescription.vue?vue&type=script&lang=ts"
export * from "./GarageDoorDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd66fe4",
  null
  
)

export default component.exports